import colors from 'assets/theme/base/colors';
import borders from 'assets/theme/base/borders';

const { borderRadius } = borders;

const menu = {
    defaultProps: {
        disableAutoFocusItem: true,
    },

    styleOverrides: {
        paper: {
            boxShadow: 'none',
            backgroundColor: colors.action.menu,
            borderRadius: borderRadius.md,
        },
    },
};

export default menu;
